import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { DataCatalogueService } from "../services/data-catalogue.service";
import { debounceTime, distinctUntilChanged } from "rxjs";
import { forkJoin } from "rxjs";

@Component({
  selector: "business-rules",
  templateUrl: "./business-rules.component.html",
  styleUrls: ["./business-rules.component.scss"],
})
export class BusinessRulesComponent implements OnInit {
  form!: FormGroup;

  rules: any[] = [];
  rulesets: any[] = [];
  features: any[] = [];

  displayedColumns: string[] = ["ruleTitle", "description"];

  private catId = "2037172d-1390-4033-9017-e5424166927e";

  constructor(
    private fb: FormBuilder,
    private catalogueService: DataCatalogueService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      byRuleTitle: [""],
    });

    this.form
      .get("byRuleTitle")!
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value) => {
        this.loadRules((value ?? "").toLowerCase());
      });

    this.loadInitialData();

    this.loadRules();
  }

  loadInitialData() {
    forkJoin({
      rulesets: this.catalogueService.getRulesets(this.catId),
      features: this.catalogueService.getFeatures(this.catId),
    }).subscribe({
      next: ({ rulesets, features }) => {
        this.rulesets = rulesets;

        this.features = features.map((f: any) => ({
          ...f,
          name: f.name?.replace("aixm:", ""),
        }));
      },
      error: (err) => console.error("Error loading initial data", err),
    });
  }

  loadRules(filter?: string) {
    this.catalogueService.getRules(this.catId, filter).subscribe({
      next: (res) => {
        this.rules = res.items;
      },
      error: (err) => {
        console.error("Error loading rules:", err);
      },
    });
  }
}
